import { render, staticRenderFns } from "./SwitchTabinfoPanel.vue?vue&type=template&id=39c51966&"
import script from "./SwitchTabinfoPanel.vue?vue&type=script&lang=js&"
export * from "./SwitchTabinfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports